import AnalyticsEvent from './AnalyticsEvent';
import type { SelectContent } from './Ga4';
import type GaItemList from './GaItemList';

export default class SelectContentAnalytics extends AnalyticsEvent<Pick<GaItemList, 'content_type' | 'content_id' | 'index'>> {
	fireFilterSelected(): void {
		super.fireGoogleAnalyticsEventOrAddListener('select_content');
	}

	static selectContent({ cId, cType = 'ux_hotelpage_click', index }: SelectContent) {
		new SelectContentAnalytics({
			content_type: cType,
			content_id: cId,
			...(index !== undefined ? { index } : {}),
		}).fireFilterSelected();
	}
}
